import OrderCountIcon from "../../assets/logo/OrderCountIcon";
import useTheme from "../../hooks/useTheme";
import { ThemeInterface } from "../../services/exports/Interfaces";
import useOrderingDisabledStatus from "../../hooks/useOrderingDisabledStatus";
import useDineInFlow from "../../hooks/useDineInFlow";
import { SCREENS } from "../../services/exports/Constants";
import { useTranslation } from "react-i18next";
import HorizontalButtons from "../buttons/HorizontalButtons";
import ButtonFooter from "./ButtonFooter";
import useNavigate from "../../hooks/useNavigate";
import useBasket from "../../hooks/useBasket";
import useAppMethods from "../../hooks/useAppMethods";

interface Props {
  title?: string;
  loading?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

export default function CartFooter(props: Props) {
  const { t } = useTranslation(null, {
    keyPrefix: "Components:Footers:CartFooter",
  });

  const { title, loading, disabled, onClick } = props;

  const { navigate } = useNavigate();
  const theme: ThemeInterface = useTheme();
  const { render: renderOrderingEnabled } = useOrderingDisabledStatus();
  const { formatCurrency } = useAppMethods();
  const { isDineIn } = useDineInFlow();
  const { quantity, total } = useBasket();

  if (renderOrderingEnabled) {
    return renderOrderingEnabled;
  }

  function onAddItems() {
    navigate(isDineIn ? SCREENS.MENU : SCREENS.HOME_SCREEN);
  }

  function renderOrderCountIcon() {
    return (
      <div className="relative mr-small">
        <OrderCountIcon color={theme.color.brand.secondary} />
        <div
          className={countContainer}
          style={{
            paddingLeft: 5,
            paddingRight: 5,
            minWidth: 25,
            minHeight: 25,
          }}
        >
          <p className="text-white mini">{quantity}</p>
        </div>
      </div>
    );
  }

  return quantity > 0 ? (
    <ButtonFooter className={container}>
      <div className={leftContainer}>
        {renderOrderCountIcon()}
        <div className={totalWrapper}>
          <p className={totalTitle}>{t("total")}</p>
          <h4 className={totalPrice}>
            {formatCurrency(total)}
          </h4>
        </div>
      </div>
      <div className="mt-small">
        <HorizontalButtons
          leftButtonProps={{
            buttonType: "forth",
            title: t("buttons.add_items"),
            onClick: onAddItems,
          }}
          rightButtonProps={{
            title,
            onClick: onClick,
            loading,
            disabled,
          }}
        />
      </div>
    </ButtonFooter>
  ) : null;
}

const container = "z-50";

const leftContainer = "flex flex-row items-center col-span-2";
const totalWrapper = "ml-4";
const totalTitle = "text-brand-text-grey mb-xTiny mini";

const totalPrice = "";

const countContainer =
  "bg-brand-secondary rounded-full border border-white absolute top-2 left-3 flex justify-center items-center";
